(function () {
  'use strict';

  function newAddresses () {
    return {
      'restrict': 'E',
      'templateUrl': 'components/new-addresses/new-addresses.html',
      'bindToController': true,
      'controller': 'NewAddressesCtrl',
      'controllerAs': 'ctrl'
    };
  }

  angular.module('web2print.newAddress')
    .directive('newAddresses', newAddresses);
})();
